/** Серия и задания дня заглушки. */
import type { PlayerState } from "../api";

export function sampleProgressFields(now: number): Pick<PlayerState, "streak" | "tasks"> {
  return {
    streak: { day: 1, claimedToday: false, todayReward: 50, expiresAt: now + 86_400_000 },
    tasks: {
      tasks: [
        { id: "kills", target: 30, progress: 0, coins: 100, claimed: false },
        { id: "waves", target: 3, progress: 0, coins: 100, claimed: false },
        { id: "upgrades", target: 3, progress: 0, coins: 100, claimed: false },
      ],
      bonus: { coins: 300, claimed: false },
      resetsAt: now + 43_200_000,
    },
  };
}
